module.exports = __webpack_public_path__ + "static/media/chevron-right-bg.ca2d455e.svg";